import { motion } from 'framer-motion';

interface PlayerStatsProps {
  rank: number;
  prizeCount: number;
  matchedCount: number;
  completionPercent: number;
}

export function PlayerStats({
  rank,
  prizeCount,
  matchedCount,
  completionPercent,
}: PlayerStatsProps) {
  return (
    <div className="glass rounded-3xl p-5 border border-white/10 shadow-glow-lg flex flex-col justify-between h-full text-left select-none">
      <div className="space-y-4">
        <h3 className="font-display text-sm font-black tracking-wider text-amber-300 uppercase">
          Your Performance
        </h3>

        {/* Info grids */}
        <div className="grid grid-cols-2 gap-3">
          {/* Rank Card */}
          <div className="glass-light p-3 rounded-xl border border-white/5 flex flex-col text-left">
            <span className="text-[9px] uppercase tracking-wider text-surface-400 font-bold">
              Your Rank
            </span>
            <span className="text-xl font-display font-black text-white mt-1">
              #{rank}
            </span>
          </div>

          {/* Prizes Coins won */}
          <div className="glass-light p-3 rounded-xl border border-white/5 flex flex-col text-left">
            <span className="text-[9px] uppercase tracking-wider text-surface-400 font-bold">
              Prizes Claimed
            </span>
            <span className="text-xl font-display font-black text-purple-400 mt-1">
              {prizeCount} 🏆
            </span>
          </div>
        </div>

        {/* Matched Count */}
        <div className="glass-light p-3.5 rounded-xl border border-white/5 flex items-center justify-between">
          <span className="text-[9px] uppercase tracking-wider text-surface-400 font-bold">
            Matched Ticket Numbers
          </span>
          <span className="text-sm font-black font-mono text-amber-400">
            {matchedCount} / 15
          </span>
        </div>

        {/* Progress Bar completion */}
        <div className="space-y-1.5">
          <div className="flex justify-between items-center text-[9px] font-bold uppercase tracking-wider text-surface-400">
            <span>Ticket Completion</span>
            <span className="font-mono text-purple-300">{completionPercent}%</span>
          </div>
          <div className="w-full h-2 rounded-full bg-slate-900 overflow-hidden border border-white/2 shadow-inner">
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: `${completionPercent}%` }}
              transition={{ duration: 1.2, ease: 'easeOut' }}
              className="h-full bg-gradient-to-r from-purple-600 to-pink-500 rounded-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default PlayerStats;
